import React, { useCallback, useEffect, useReducer, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
} from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import Grid from "@mui/material/Grid";
import MaterialBox from "../../../components/MaterialBox";
import MaterialSelect from "../../../components/MaterialSelect";
import { taskCreationData, taskcreationStateMange } from "../taskCreationData";
import MaterialInput from "../../../components/MaterialInput";
import FileSelector from "../../../components/fileSelector";
import MaterialButton from "../../../components/MaterialButton";
import MultiSelectAutocomplete from "../../../components/MultiSelectAutocomplete";
import { BASE_URL, fetchData, postData, putData } from "../../Utils/Baseurl";
import { useLoading } from "../../../context/loadingcontext";
import { useLocation, useNavigate } from "react-router-dom";
import { useSnackbar } from "../../../components/SnackbarProvider";
import ChatBot from "../../chatbot";
import MaterialDatePicker from "../../../components/MaterialDatePicker";
import CustomSelectField from "../../../components/CustomSelectField";
import axios from "axios";


const TaskCreationForm = ({ isDialog = false, project_id, fetchTaskList, onClose, type: propType, data: propData }) => {
  const location = useLocation();
  const user_id = sessionStorage.getItem("currentUse");
  const { freeze } = location.state || {};
  const [taskData, dispatch] = useReducer(
    taskcreationStateMange,
    taskCreationData
  );
  const [teamMembersData, setTeamMembersData] = useState([]);
  const [inputDisble, setInputDisble] = useState(false);
  const [projectNameOption, setProjectNameOption] = useState([]);
  const [priorityOption, setPriorityOption] = useState([]);
  const [team, setTeam] = useState([])

  const [priorityLoading, setPriorityLoading] = useState(false);
  const [chatBotStatus, setChatBotStatus] = useState(false);
  const [employeeData, setEmployeeData] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);

  const [allocatedMembers, setAllocatedMembers] = useState([]);
  const [mileStoneOption, setMileStoneOption] = useState([]);
  const [taskCountId, setTaskCountId] = useState("");
  const [assginMembersOption, setAssginMembersOption] = useState([]);
  const [moduleOption, setModuleOption] = useState([]);

  const [suggestion, setSuggestion] = useState("");
  const { setCirleLoading } = useLoading();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);

  const type = propType || location?.state?.type;
  const data = propData || location?.state?.data;

  useEffect(() => {
    if (type === "view") {
      setInputDisble(true);
    } else {
      setInputDisble(false);
    }
  }, [type]);

  // useEffect(() => {
  //   fetchProjectTasks(user_id, project_id);
  // }, [project_id]);

  useEffect(() => {
    if (data) {
      dispatch({
        value: { value: data?.project, label: data?.project_name },
        name: "projectName",
      });
      fetchTeamsDependince(project_id);
      dispatch({
        value: { value: data?.priority_level, label: data?.priority_level },
        name: "priority",
      });
      dispatch({
        value: { value: data?.Assignee, label: data?.assignee_name },
        name: "assignemnt",
      });

      dispatch({
        value: data?.module,
        name: "moduleName",
      });

      if (data?.milestone) {
        fetchModuleapi(data.milestone);
        dispatch({
          value: { value: data?.module, label: data?.module_name },
          name: "moduleName",
        });
      }


      dispatch({
        value: data?.task_title,
        name: "tasktitle",
      });
      dispatch({
        value: data?.task_describtion,
        name: "taskDescrpition",
      });
      dispatch({
        value: data?.task_creater_name,
        name: "reporter",
      });
      dispatch({
        value: data?.start_date,
        name: "startDate",
      });
      dispatch({
        value: data?.end_date,
        name: "endDate",
      });
      dispatch({
        value: data?.assigned_hours,
        name: "assginHours",
      });
      dispatch({
        value: { value: data?.sprint, label: data?.sprint_number },
        name: "sprint",
      });
      dispatch({
        value: { value: data?.milestone, label: data?.milestone_name },
        name: "milestone",
      });
      dispatch({
        value: data?.attachment,
        name: "attachement",
      });
      fetchMileapi(project_id);
      const updatedStakeHolders = data?.stake_holder?.map((item) => ({
        ...item,
        employee_name: item.user_name,
        id: item?.user_id,
      }));
      dispatch({
        value: { value: data?.teams, label: data?.teams },
        name: "teams",
      });
      setTaskCountId(data?.task_code);

      fetchAssginDependice(data?.team_name);

      dispatch({ value: updatedStakeHolders, name: "statusHolder" });
    }
  }, [data]);


  const fetchChatBotData = async (id) => {

    setCirleLoading(true);

    try {
      const res = await fetchData(`/ai/suggest-employee/${id}/`);

      if (res) {
        setChatBotStatus(true);
        const suggestionText = res.suggestion;
        setSuggestion(suggestionText);
      }
    } catch (error) {
      console.error("Error fetching suggestion:", error);

      setSuggestion("Error fetching suggestion.");
    } finally {
      setCirleLoading(false);
    }
  };

  useEffect(() => {
    setEmployeeData([
      { id: 1, username: "John" },
      { id: 2, username: "Jane" },
      { id: 3, username: "Alice" },
    ]);
    fetchProjectData();
    fetchPriorityData();
    dispatch({
      value: currentUser?.employee_name,
      name: "reporter",
    });
    fetchTeamMembers();
  }, []);

  // Fetch milestones and team members when project_id is available
  useEffect(() => {
    if (project_id) {
      console.log('Fetching data for project_id:', project_id);
      fetchMileapi(project_id);
      fetchTeamsDependince(project_id);
      if (type !== 'edit') {
        fetchTaskCode(project_id);
      }
    }
  }, [project_id, type]);

  const handleMultipleSelect = (event, newValue) => {
    setSelectedEmployees(newValue);
    dispatch({ value: newValue, name: "statusHolder" });
  };

  const handleMileChange = (e, s) => {
    dispatch({ value: e, name: "milestone" });
    dispatch({ value: "", name: "moduleName" });
    if (e?.value) {
      fetchModuleapi(e.value);
    } else {
      setModuleOption([]);
    }
    setSelectedStartDate(e?.startDate || null);
    setSelectedEndDate(e?.endDate || null);

  };


  const fetchProjectData = async () => {
    const formData = new FormData();
    formData.append("user_id", currentUser);
    try {
      const res = await postData("/api/getProject/", formData);

      if (res?.status) {
        setProjectNameOption(res?.data);
      } else {
        setProjectNameOption([]);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchTeamMembers = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${BASE_URL}api/create_user/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      const transformedData = data.data.map((item) => ({
        id: item.id,
        employee_name: item?.employee_name,
        team: item.team?.team_name,
      }));
      setTeamMembersData(transformedData);
    } catch (error) {
      console.error("Error fetching team members:", error);
    }
  };
  const fetchPriorityData = async () => {
    try {
      const data = await fetchData("api/priority/");

      const status = data?.status;
      if (status) {
        setPriorityOption(data?.data);
      } else {
        setPriorityOption([]);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleAdd = async () => {
    const newId = taskData?.statusHolder?.map((v) => ({
      user_id: v.id,
    }));

    const formdata = new FormData();

    formdata.append("task_code", taskCountId);
    formdata.append("project_id", project_id);
    formdata.append("task_title", taskData?.tasktitle);
    formdata.append("task_describtion", taskData?.taskDescrpition);
    formdata.append("team_name", taskData?.teams?.label);
    formdata.append("Assignee_id", taskData?.assignemnt?.value);
    formdata.append("task_creater_id", currentUser);
    if (taskData?.statusHolder?.length) {
      formdata.append("stake_holder", JSON.stringify(newId));
    } else {
      formdata.append("stake_holder", JSON.stringify(taskData?.statusHolder));
    }
    formdata.append("start_date", taskData?.startDate);
    formdata.append("end_date", taskData?.startDate);
    formdata.append("assigned_hours", taskData?.assginHours);
    formdata.append("milestone_id", taskData?.milestone?.value);
    formdata.append("module", taskData?.moduleName?.value);
    formdata.append("attachment", taskData?.attachement ?? "");
    formdata.append("priority_level", taskData?.priority?.label);
    formdata.append("is_frozen", freeze);
    if (freeze) {
      formdata.append("reason", taskData?.reason)
    }
    try {
      setCirleLoading(true);
      const data = await postData("api/taskcreation/", formdata);
      if (data?.status) {
        showSnackbar(data?.message, "success");
        fetchTaskList();

        if (project_id) {
          fetchTaskCode(project_id);
        }

        dispatch({ value: "", name: "tasktitle" });
        dispatch({ value: "", name: "assginHours" });

      } else {
        showSnackbar(data?.message, "error");
      }
    } catch (error) {
      let message = "An unexpected error occurred";
      if (error?.response?.data?.message) {
        message = error.response.data.message;
      } else if (error?.message) {
        message = error.message;
      }

      showSnackbar(message, "error");
    } finally {
      setCirleLoading(false);
    }
  };

  const handleFileSelect = (file) => {
    dispatch({
      value: file,
      name: "attachement",
    });
  };

  const fetchAssginDependice = (value) => {
    const filterData = allocatedMembers?.filter(
      (v, i) => v?.team?.toLowerCase() === value?.toLowerCase()
    );
    setAssginMembersOption(filterData);
  };

  const handleTeamChange = async (e, s) => {
    const value = e?.label;
    if (e) {
      fetchAssginDependice(value);
    }

    dispatch({ value: e, name: s?.name });
  };

  const fetchTeamsDependince = async (id) => {
    try {
      const formdata = new FormData();
      formdata.append("project_id", id);
      const data = await postData("/api/getallocatedresources/", formdata);

      const status = data?.status;
      if (status) {
        let team = [];
        if (data?.data) {
          data?.data?.map((item) => {
            if (!team.includes(item?.team)) {
              team.push(item?.team);
            }
          });

          setTeam(team)
        }

        setAllocatedMembers(data?.data);
      } else {
        setAllocatedMembers([]);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleProductChange = async (e, s) => {
    const id = e?.value;
    console.log(id, 'idddd')
    if (e) {
      fetchTeamsDependince(project_id);
      fetchChatBotData(project_id); // Fixed: Use project_id instead of dropdown value
      fetchMileapi(project_id);
      fetchTaskCode(project_id);
    } else {
      setAllocatedMembers([]);
      setChatBotStatus(false);
      setTaskCountId("");
    }
    dispatch({ value: e, name: s?.name });
  };

  const fetchTaskCode = async (id) => {
    const formdata = new FormData();
    formdata.append("project_id", id);
    try {
      const data = await postData("/api/getTaskCount/", formdata);
      if (data?.status) {
        setTaskCountId(data?.data?.task_count);
      } else {
        setTaskCountId("");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchMileapi = async (id) => {
    const formData = new FormData();
    formData.append("project_id", id);
    try {
      const res = await postData("/api/getMilestone/", formData);

      if (res?.status) {
        setMileStoneOption(res?.data);
      } else {
        setMileStoneOption([]);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchModuleapi = async (id) => {
    try {
      const res = await fetchData(`/api/project_module/?milestone=${id}&page_size=200`);
      if (res?.status) {
        setModuleOption(res?.data);
      } else {
        setModuleOption([]);
      }
    } catch (err) {
      console.log(err);
    }
  };


  const handleCreateCustomOption = async (newValue) => {
    console.log(newValue, 'newValue')
    try {
      const formdata = new FormData();
      formdata.append("name", newValue);
      console.log(formdata, 'formdata')
    } catch (error) {
      showSnackbar("Error creating option", "error");
    }
  };


  const handleStartDateChange = (data) => {
    if (!data || !data[0]) return;

    const date = new Date(data[0]);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}`;

    console.log(formattedDate, "formatted date");

    dispatch({ value: formattedDate, name: "startDate" });
    dispatch({ value: formattedDate, name: "endDate" });
  };

  const handleEndDateChange = (data) => {
    if (!data || !data[0]) return;

    const date = new Date(data[0]);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}`;

    console.log(formattedDate, "formatted date");

    dispatch({ value: formattedDate, name: "endDate" });
  };


  const handleUpdate = async () => {
    const newId = taskData?.statusHolder?.map((v) => ({
      user_id: v.id,
    }));

    const formdata = new FormData();

    formdata.append("project_id", project_id);
    formdata.append("task_title", taskData?.tasktitle);
    formdata.append("task_describtion", taskData?.taskDescrpition);
    formdata.append("team_name", taskData?.teams?.label);
    formdata.append("Assignee_id", taskData?.assignemnt?.value);
    formdata.append("task_creater_id", currentUser);
    if (taskData?.statusHolder?.length) {
      formdata.append("stake_holder", JSON.stringify(newId));
    } else {
      formdata.append("stake_holder", JSON.stringify(taskData?.statusHolder));
    }
    formdata.append("start_date", taskData?.startDate);
    formdata.append("end_date", taskData?.startDate);
    formdata.append("assigned_hours", taskData?.assginHours);
    formdata.append("milestone_id", taskData?.milestone?.value);
    formdata.append("sprint_id", taskData?.sprint?.value);
    formdata.append("module", taskData?.moduleName?.value);

    if (taskData?.attachement instanceof File) {
      formdata.append("attachment", taskData.attachement);
    }
    formdata.append("priority_level", taskData?.priority?.label);
    if (freeze) {
      formdata.append("reason", taskData?.reason)
    }
    try {
      setCirleLoading(true);
      const res = await putData(`api/taskcreation/${data?.id}/`, formdata);
      if (res?.status) {
        showSnackbar(res?.message, "success");
        fetchTaskList();
        if (!isDialog) {
          navigate("/task-creation/task-list", { state: { project_id: project_id } });
        }
      } else {
        showSnackbar(res?.message, "error");
      }
    } catch (error) {
      let message = "An unexpected error occurred";
      if (error?.response?.data?.message) {
        message = error.response.data.message;
      } else if (error?.message) {
        message = error.message;
      }

      showSnackbar(message, "error");
    } finally {
      setCirleLoading(false);
    }
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    const isFrozenValid = (freeze >= 0 || freeze === "true") ? taskData.reasonStatus === "success" : true;

    if (
      taskData.projectNameStatus === "success" &&
      taskData.tasktitleStatus === "success" &&
      taskData.teamsStatus === "success" &&
      taskData.assignemntStatus === "success" &&
      taskData.reporterStatus === "success" &&
      taskData.startDateStatus === "success" &&
      taskData.endDateStatus === "success" &&
      taskData.assginHoursStatus === "success" &&
      taskData.milestoneStatus === "success" &&
      taskData.moduleNameStatus === "success" &&
      isFrozenValid
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };


  const content = (
    <Card sx={{ boxShadow: isDialog ? "none" : "inherit" }}>
      {!isDialog && (
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Task Creation
                </MaterialTypography>
              </Stack>
            </Stack>
          }
        />
      )}
      {chatBotStatus && (
        <div className="chatbox-container">
          <ChatBot suggestionText={suggestion} />
        </div>
      )}

      <CardContent sx={{ minHeight: isDialog ? "auto" : "90vh", p: isDialog ? 1 : 2 }}>
        <MaterialBox>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Task code
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                size="small"
                value={taskCountId}
                name="taskCode"
                placeholder="Enter Task Code"
                disabled={true}
                success={taskCountId ? true : false}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Milestone <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>

              <MaterialSelect
                name="milestone"
                size="small"
                value={taskData?.milestone}
                customStyles={{ optionPadding: 20 }}
                isDisabled={project_id ? inputDisble : true}
                options={mileStoneOption?.map((item) => {
                  return {
                    value: item?.id,
                    label: item?.milestone_name,
                    startDate: item?.start_date,
                    endDate: item?.end_date,
                  };
                })}
                onChange={(e, s) => handleMileChange(e, s)}
                isClearable
                error={taskData?.milestoneStatus === "error" ? true : false}
                success={
                  taskData?.milestoneStatus === "success" ? true : false
                }
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Module Name <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="moduleName"
                size="small"
                value={taskData?.moduleName}
                customStyles={{ optionPadding: 20 }}
                isDisabled={taskData?.milestone ? inputDisble : true}
                options={moduleOption?.map((item) => {
                  return {
                    value: item?.id,
                    label: item?.module_name,
                  };
                })}
                onChange={(e, s) =>
                  dispatch({ value: e, name: "moduleName" })
                }
                isClearable
                error={taskData.moduleNameStatus === "error" ? true : false}
                success={
                  taskData.moduleNameStatus === "success" ? true : false
                }
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Task title <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                size="small"
                value={taskData?.tasktitle}
                name="tasktitle"
                placeholder="Enter Task title"
                disabled={inputDisble}
                onChange={(e) =>
                  dispatch({ value: e?.target?.value, name: "tasktitle" })
                }
                error={taskData.tasktitleStatus === "error" ? true : false}
                success={
                  taskData.tasktitleStatus === "success" ? true : false
                }
              />
              {taskData.tasktitleStatus === "error" ? (
                <FormControl error>
                  <FormHelperText>
                    Task title must be between 1 and 100 letters.{" "}
                  </FormHelperText>
                </FormControl>
              ) : null}
            </Grid>

            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Team <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="teams"
                size="small"
                value={taskData?.teams}
                customStyles={{ optionPadding: 20 }}
                isDisabled={project_id ? inputDisble : true}
                options={team?.map((item) => {
                  return {
                    value: item,
                    label: item,
                  };
                })}
                onChange={(e, s) => handleTeamChange(e, s)}
                isClearable
                error={taskData.teamsStatus === "error" ? true : false}
                success={
                  taskData.teamsStatus === "success" ? true : false
                }
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Assign Member <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="assignemnt"
                size="small"
                value={taskData?.assignemnt}
                customStyles={{ optionPadding: 20 }}
                isDisabled={taskData?.teams && project_id ? inputDisble : true}
                options={assginMembersOption?.map((item) => {
                  return {
                    value: item?.id,
                    label: item?.employee_name,
                  };
                })}
                onChange={(e, s) => dispatch({ value: e, name: s?.name })}
                isClearable
                error={taskData?.assignemntStatus === "error" ? true : false}
                success={
                  taskData?.assignemntStatus === "success" ? true : false
                }
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Stake Holder
                </MaterialTypography>
              </MaterialBox>
              <MultiSelectAutocomplete
                id="employee-selector"
                size="small"
                placeholder="Add employees"
                options={teamMembersData.map((member) => ({
                  employee_name: member.employee_name,
                  id: member.id,
                  teams: member?.team,
                }))}
                value={taskData?.statusHolder}
                onChange={handleMultipleSelect}
                disabled={project_id ? inputDisble : true}
                labelKey="employee_name"
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Start Date <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialDatePicker
                value={taskData?.startDate}
                size="small"
                type="date"
                name="startDate"
                placeholder="Enter Start Date"
                disabled={inputDisble}
                onChange={handleStartDateChange}
                error={taskData.startDateStatus === "error" ? true : false}
                success={
                  taskData.startDateStatus === "success" ? true : false
                }
                options={{
                  minDate: selectedStartDate,
                  maxDate: selectedEndDate,
                  onDayCreate: (dObj, dStr, fp, dayElem) => {
                    const dayOfWeek = dayElem.dateObj.getDay();

                    if (selectedStartDate && selectedEndDate) {
                      const start = new Date(selectedStartDate).setHours(0, 0, 0, 0);
                      const end = new Date(selectedEndDate).setHours(0, 0, 0, 0);
                      const day = dayElem.dateObj.setHours(0, 0, 0, 0);

                      if (dayOfWeek === 0 || dayOfWeek === 6) {
                        dayElem.style.backgroundColor = "#EB5453";
                        dayElem.style.color = "#fff";
                        dayElem.style.borderRadius = "50%";
                      }

                      // ✅ Highlight full range in green
                      if (day >= start && day <= end) {
                        dayElem.style.backgroundColor = "#86C489";
                        dayElem.style.color = "#fff";
                        dayElem.style.borderRadius = "50%";
                        dayElem.style.fontWeight = "bold";
                      }

                      // ✅ Make weekends inside project range blue
                      if (dayOfWeek === 0 || dayOfWeek === 6) {
                        if (day >= start && day <= end) {
                          dayElem.style.backgroundColor = "#F3CBC9";
                          dayElem.style.color = "#fff";
                          dayElem.style.borderRadius = "50%";
                          dayElem.style.fontWeight = "bold";
                        }
                      }
                    } else {
                      // ✅ If no range selected, just mark weekends as red (outside project)
                      if (dayOfWeek === 0 || dayOfWeek === 6) {
                        dayElem.style.backgroundColor = "#EB5453";
                        dayElem.style.color = "#fff";
                        dayElem.style.borderRadius = "50%";
                      }
                    }
                  },
                }}
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  End Date <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialDatePicker
                value={taskData?.endDate}
                size="small"
                type="date"
                name="endDate"
                placeholder="Enter End Date"
                disabled={true}
                input={{ disabled: true }}
                onChange={handleEndDateChange}
                error={taskData.endDateStatus === "error" ? true : false}
                success={taskData.endDateStatus === "success" ? true : false}
                inputProps={{
                  min: taskData?.startDate,
                  max: selectedEndDate,
                }}
                options={{
                  minDate: taskData?.startDate ? taskData?.startDate : selectedStartDate,
                  maxDate: selectedEndDate,
                  clickOpens: false,
                  onDayCreate: (dObj, dStr, fp, dayElem) => {
                    const dayOfWeek = dayElem.dateObj.getDay();

                    if (selectedStartDate && selectedEndDate) {
                      const start = new Date(selectedStartDate).setHours(0, 0, 0, 0);
                      const end = new Date(selectedEndDate).setHours(0, 0, 0, 0);
                      const day = dayElem.dateObj.setHours(0, 0, 0, 0);

                      if (dayOfWeek === 0 || dayOfWeek === 6) {
                        dayElem.style.backgroundColor = "#EB5453";
                        dayElem.style.color = "#fff";
                        dayElem.style.borderRadius = "50%";
                      }

                      // ✅ Highlight full range in green
                      if (day >= start && day <= end) {
                        dayElem.style.backgroundColor = "#86C489";
                        dayElem.style.color = "#fff";
                        dayElem.style.borderRadius = "50%";
                        dayElem.style.fontWeight = "bold";
                      }

                      // ✅ Make weekends inside project range blue
                      if (dayOfWeek === 0 || dayOfWeek === 6) {
                        if (day >= start && day <= end) {
                          dayElem.style.backgroundColor = "#F3CBC9";
                          dayElem.style.color = "#fff";
                          dayElem.style.borderRadius = "50%";
                          dayElem.style.fontWeight = "bold";
                        }
                      }
                    } else {
                      // ✅ If no range selected, just mark weekends as red (outside project)
                      if (dayOfWeek === 0 || dayOfWeek === 6) {
                        dayElem.style.backgroundColor = "#EB5453";
                        dayElem.style.color = "#fff";
                        dayElem.style.borderRadius = "50%";
                      }
                    }
                  },
                }}
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Assign hours <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                value={taskData?.assginHours}
                size="small"
                // type="number"
                name="assginHours"
                placeholder="Enter Assigned hours"
                disabled={inputDisble}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val === "" || /^\d*\.?\d*$/.test(val)) {
                    dispatch({ value: val, name: "assginHours" });
                  }
                }}
                error={taskData.assginHoursStatus === "error" ? true : false}
                success={
                  taskData.assginHoursStatus === "success" ? true : false
                }
                onKeyDown={(e) => {
                  if (["e", "E", "+", "-"].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                sx={{
                  "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                  {
                    WebkitAppearance: "none",
                    margin: 0,
                  },
                  "& input": {
                    MozAppearance: "textfield",
                  },
                }}
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Priority <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="priority"
                size="small"
                value={taskData?.priority}
                customStyles={{ optionPadding: 20 }}
                isDisabled={inputDisble}
                options={priorityOption?.map((item) => {
                  return {
                    value: item?.id,
                    label: item?.priority,
                  };
                })}
                onChange={(e, s) => dispatch({ value: e, name: s?.name })}
                isClearable
                isLoading={priorityLoading}
                error={taskData?.priorityStatus === "error" ? true : false}
                success={
                  taskData?.priorityStatus === "success" ? true : false
                }
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Task description
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                multiline
                size="small"
                rows={3}
                value={taskData?.taskDescrpition}
                name="taskDescrpition"
                placeholder="Enter Task description"
                disabled={inputDisble}
                onChange={(e) =>
                  dispatch({
                    value: e?.target?.value,
                    name: "taskDescrpition",
                  })
                }
                error={
                  taskData.taskDescrpitionStatus === "error" ? true : false
                }
                success={
                  taskData.taskDescrpitionStatus === "success" ? true : false
                }
              />
              {taskData.taskDescrpitionStatus === "error" ? (
                <FormControl error>
                  <FormHelperText>
                    Task description must be between 1 and 250 letters.{" "}
                  </FormHelperText>
                </FormControl>
              ) : null}
            </Grid>

            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Attachement
                </MaterialTypography>
              </MaterialBox>

              <FileSelector
                onFileSelect={handleFileSelect}
                fileUrl={data?.attachment}
                disabled={inputDisble}
              />
            </Grid>

            {/* <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Custom Field
                </MaterialTypography>
              </MaterialBox>
              <CustomSelectField
                name="customField"
                value={customFieldValue}
                options={customFieldOption}
                onChange={(newValue) => setCustomFieldValue(newValue)}
                onCreate={handleCreateCustomOption}
                disabled={inputDisble}
              />
            </Grid> */}

            {freeze >= 0 && (
              <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Reason <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  multiline
                  rows={4}
                  value={taskData?.reason}
                  name="reason"
                  placeholder="Enter Reason for the new task"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "reason" })
                  }
                  error={taskData.reasonStatus === "error" ? true : false}
                  success={taskData.reasonStatus === "success" ? true : false}
                />
                {taskData.reasonStatus === "error" ? (
                  <FormControl error>
                    <FormHelperText>
                      Reason must be between 1 and 250 letters.{" "}
                    </FormHelperText>
                  </FormControl>
                ) : null}
              </Grid>
            )}
          </Grid>
        </MaterialBox>

        <MaterialBox
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          mt={2}
        >
          <MaterialButton
            onClick={() => {
              if (isDialog && onClose) {
                onClose();
              } else if (!isDialog) {
                navigate("/task-creation/task-list");
              }
            }}
            sx={{ m: 1 }}
            variant="gradient"
            color="dark"
          >
            Cancel
          </MaterialButton>
          {(type !== "view" || !isDialog) && (
            <MaterialButton
              sx={{ m: 1 }}
              variant="gradient"
              color="dark"
              disabled={!checkAllFields()}
              onClick={type === "edit" ? handleUpdate : handleAdd}
            >
              {type === "edit" ? "Update" : "Submit"}
            </MaterialButton>
          )}
        </MaterialBox>
      </CardContent>
    </Card>
  );

  if (isDialog) {
    return content;
  }

  return (
    <DashboardLayout>
      {content}
    </DashboardLayout>
  );
};

export default TaskCreationForm;


